<script lang="ts" module>
  import type { AnyConfigurationSection } from '@/teoCore/config/config-setup.types';
  import { isTeoError, TeoError } from '@/teoCore/errors/TeoError';
  import LinkButton from '@/ui/elements/buttons/LinkButton.svelte';
  import { useHasViewType } from '@/ui/state/use-text-state.svelte';
  import { useShowPDFPreview } from '@/utils/teo-context/flags';

  import { createConfigPanel } from './AnalysisConfigPanel.builder.svelte';
  import type { ConfigPanelProps } from './AnalysisConfigPanel.utils';
  import ConfigCard from './cmps/ConfigCard.svelte';
  import ConfigMenuBtn from './cmps/ConfigMenuBtn.svelte';
</script>

<script lang="ts" generics="TSection extends AnyConfigurationSection">
  import ReportPdfPreview from '../report/ReportPdfPreview.svelte';

  let props: ConfigPanelProps<TSection> = $props();
  let hidden = useHasViewType('new');

  let { setup } = props;
  const C = createConfigPanel(props);
  const [showPDFPreview] = useShowPDFPreview();
</script>

{#if !$hidden}
  <div
    class="fc-xc gap-4 rounded-md bg-plain px-4 pb-3 pt-4 shadow-card transition-all"
    use:C.closeOnClickOutside
  >
    {#if showPDFPreview.current}
      <ReportPdfPreview />
    {/if}
    <div class="fc-ns gap-1">
      <div class="fr-csb gap-2 text-lsm font-normal">
        <span class="p-1 font-medium">Konfiguration</span>

        <ConfigMenuBtn
          onChange={(active) => C.handleSectionSelect(active ? 'all' : C.currentSection)}
          active={!!C.currentSection}
        />
      </div>
      <div class="frw-cs f-1 w-full flex-wrap gap-2 text-lsm font-normal">
        {#if !setup}
          <span class="p-1">...</span>
        {:else if TeoError.isError(setup)}
          <span class="p-1">Fehler: {setup.message}</span>
        {:else}
          {#each setup.sections as section (section.id)}
            <div class="px-1">
              <LinkButton
                highlight={!!C.currentValues[section.id]}
                onclick={() => C.handleSectionSelect(section.id)}
                active={C.currentSection === section.id}>{C.getTabTitle(section)}</LinkButton
              >
            </div>
            {#if !C.isLastSection(section)}
              <span role="separator">•</span>
            {/if}
          {/each}
        {/if}
      </div>
    </div>

    {#if C.currentSection && setup && !isTeoError(setup)}
      <div class="fc gap-3 border-t border-c-divider pt-3 transition-all">
        {#each setup.sections as section (section.id)}
          {#if C.currentSection === section.id || C.currentSection === 'all'}
            <ConfigCard
              groupName={section.id}
              title={section.title}
              description={section.description}
              options={section.options}
              value={C.currentValues[section.id]}
              onchange={(value) => C.handleValueChange(section.id, value)}
            />
          {/if}
        {/each}
      </div>
    {/if}
  </div>
{/if}
